<span [ngStyle]="getStyle()"
      style="
      border: 1px solid !important;
      border-radius:40px;
      padding:2px 12px;
      margin: 2px 2px;
      font-size: 12px;
      display: inline-block;
">{{title|translate}}</span>
